export default function getResource(label) {
    const resources = {
        noProducts: 'Désolé, aucun article ne correspond aux filtres appliqués.'
    };

    return resources[label];
}
